import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { translateFn } from '../../../../utils/translator.helper';
import { ConsoleRequest, DataProviderEntity, DataProviderType } from '../../../../utils/request';
import { AD_CHANGE_EVENT } from '../setADIntegrator/component/interfaces';
import { GzRemoveADIntegratorWebComponent } from './component';

export class RemoveADIntegratorPopUp extends NetworkBasePopUp<GzRemoveADIntegratorWebComponent> {
  protected extraDialogConfigs: Partial<GzDialog> = {
    isWindow: false,
  };
  protected title = translateFn('Remove Active Directory Integrator?');
  protected customEventNameAfterConfirm = AD_CHANGE_EVENT;

  protected customSetup(): void {
    this.popUpContent = new GzRemoveADIntegratorWebComponent();
    this.popUpFooterButtons = [
      {
        id: 'confirmButton',
        label: translateFn('Remove'),
      },
      {
        id: 'closeButton',
        label: translateFn('Cancel'),
      },
    ];
    this.popUpContent.domainName = this.data.specifics.domainName;
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    if (!this.data.targets) {
      throw new Error('Targets are not defined');
    }

    const protectedEntityId = this.data.targets[0]._id;
    try {
      await ConsoleRequest.createRequest<boolean>({
        dataProviderType: DataProviderType.ENDPOINTS,
        dataProviderEntity: DataProviderEntity.MODEL,
        endpoint: 'UnifiedEndpoints',
        method: 'unsetAdCloudIntegrator',
        payload: {
          protectedEntityId: protectedEntityId,
        },
      });
    } catch (e) {
      console.error(e);
      this.showErrorToastNotification(translateFn('Failed to remove AD Integrator.'));
    }

    this.showCustomToast(translateFn('AD Integrator successfully removed.'));
  }

  protected getCustomEventDetail(): any {
    return {};
  }
}
